import Vue from 'vue'
import App from './App'
import router from './router/example'
import store from './store'
import 'amfe-flexible'
import './assets/css/style.css'
import './plugins/vant'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
